import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import Gelateria from "@/pages/Gelateria";
import ContattiPage from "@/pages/ContattiPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App bg-paper min-h-screen">
          <div className="grain-overlay" aria-hidden="true" />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/gelateria" element={<Gelateria />} />
            <Route path="/contatti" element={<ContattiPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
